export default __webpack_public_path__ + "static/media/icon-filter.f4932c14.svg";